/**
 * Presence Types
 * Type definitions for presence tracking and user status management
 */
/**
 * Presence status enum
 * Matches backend PresenceStatus enum (numeric values)
 * IMPORTANT: Backend expects numeric values (0, 1, 2, 3)
 */
export var PresenceStatus;
(function (PresenceStatus) {
    PresenceStatus[PresenceStatus["Offline"] = 0] = "Offline";
    PresenceStatus[PresenceStatus["Online"] = 1] = "Online";
    PresenceStatus[PresenceStatus["Away"] = 2] = "Away";
    PresenceStatus[PresenceStatus["Busy"] = 3] = "Busy";
})(PresenceStatus || (PresenceStatus = {}));
/**
 * Default activity detector options
 */
export const DEFAULT_ACTIVITY_OPTIONS = {
    inactivityTimeout: 5 * 60 * 1000, // 5 minutes
    checkInterval: 30 * 1000, // 30 seconds
    throttleDelay: 1000, // 1 second
};
//# sourceMappingURL=types.js.map